export default {
  order: 5,
  name: "Requisition",
  icon: "receipt_long",
  to: "/requisition/ReqDashboard",
  enabled: true,
  subs: [
    // {
    //   name: "User Requisition",
    //   icon: "recent_actors",
    //   to: "/requisition/list/VXNlcl94MDAyMF9SZXF1aXNpdGlvbg==",
    //   enabled: true,
    // },
    {
      name: "Purchase Requisition",
      icon: "payments",
      to: "/requisition/list/UHVyY2hhc2VfeDAwMjBfUmVxdWlzaXRpb24=",
      enabled: true,
    },
    {
      name: "Store Requisition",
      icon: "archive",
      to: "/requisition/list/U3RvcmVfeDAwMjBfUmVxdWlzaXRpb24=",
      enabled: true,
    },
  ],
};
